import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TalentCard from '../components/TalentCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function RosterPage() {
  const [talents, setTalents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchTalents();
  }, []);

  const fetchTalents = async () => {
    try {
      const response = await axios.get(`${API}/talents/public`);
      setTalents(response.data);
    } catch (error) {
      console.error('Error fetching talents:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredTalents = filter === 'all' 
    ? talents 
    : talents.filter(t => t.representation_type?.toLowerCase() === filter);

  const representationTypes = [...new Set(talents.map(t => t.representation_type).filter(Boolean))];

  return (
    <div>
      <Header />
      
      <div className="page-header" data-testid="roster-header">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="section-subtitle">Our Talent</p>
            <h1 className="section-title">Meet Our Roster</h1>
            <p className="section-description">
              Discover the exceptional performers represented by Woodhouse & Archer.
            </p>
          </motion.div>
        </div>
      </div>

      <section className="section section-dark" data-testid="roster-section">
        <div className="container">
          {/* Filter */}
          {representationTypes.length > 0 && (
            <div style={{ marginBottom: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
              <button
                className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-ghost'}`}
                onClick={() => setFilter('all')}
                data-testid="filter-all"
              >
                All
              </button>
              {representationTypes.map(type => (
                <button
                  key={type}
                  className={`btn ${filter === type.toLowerCase() ? 'btn-primary' : 'btn-ghost'}`}
                  onClick={() => setFilter(type.toLowerCase())}
                  data-testid={`filter-${type.toLowerCase()}`}
                >
                  {type}
                </button>
              ))}
            </div>
          )}

          {loading ? (
            <div className="loading">
              <div className="spinner" />
            </div>
          ) : filteredTalents.length === 0 ? (
            <div className="empty-state" data-testid="empty-roster">
              <div className="empty-state-icon">🎭</div>
              <h3>No talent profiles yet</h3>
              <p>Check back soon as we add new performers to our roster.</p>
            </div>
          ) : (
            <motion.div 
              className="roster-grid"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              {filteredTalents.map((talent, index) => (
                <motion.div
                  key={talent.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <TalentCard talent={talent} />
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
